"use client";

import { Typography } from "antd";
import React from "react";
import OurTeamSlider from "./ourTeamSlider";

const OurTeam = () => {
  const { Title } = Typography;
  return (
    <div className="flex flex-col">
      <div className="flex flex-col items-center container">
        <Title level={2} className="H2 text-center">
          تیم ما
        </Title>
        <p className="text-regal-black-lighter text-base text-center w-full sm:w-2/3">
          ما فقط یک تیم نیستیم، ما معماران آینده‌ای سبز هستیم. ما در تا برق
          همراه شماییم؛ دغدغه‌مان این است که فرآیند شما را از هرگونه چالش و مانع
          پاک کنیم. از اولین مرحله تا روشن شدن پنل‌ها، همه چیز را رصد می‌کنیم و
          تا زمانی که لبخند رضایت شما را نبینیم، دست از کار نمی‌کشیم.
        </p>
      </div>
      <div className="w-full flex items-start justify-center mx-auto px-8 sm:px-12 lg:px-0 max-w-[44rem]">
        <OurTeamSlider />
      </div>
    </div>
  );
};

export default OurTeam;
